import React from 'react';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Collapse from '@material-ui/core/Collapse';
import Icon from '../Icon';
import styled from 'styled-components';

const Container = styled(Paper)`
  && {
    margin-bottom: ${props => props.theme.spacing(2)}px;
  }
`;

const ContainerHeader = styled.div`
  color: #999;
  cursor: pointer;
  padding: ${props => props.theme.spacing()}px;
  display: flex;
  align-items: center;
`;

const ContainerHeaderInner = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;
`;

const CollapseCard = ({ children, title, onSelect, removable, onRemove, isOpen }) => (
  <Container>
    <ContainerHeader onClick={onSelect} onKeyPress={onSelect} role="button" tabIndex="0">
      <ContainerHeaderInner>
        {typeof title === 'function' ? title : <Typography variant="subtitle2">{title}</Typography>}
        {removable && (
          <IconButton size="small" onClick={onRemove}>
            <Icon icon={['fal', 'trash-alt']} size="small" />
          </IconButton>
        )}
      </ContainerHeaderInner>
    </ContainerHeader>
    <Collapse in={isOpen}>{children}</Collapse>
  </Container>
);

CollapseCard.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  removable: PropTypes.bool,
  isOpen: PropTypes.bool,
  onSelect: PropTypes.func,
  onRemove: PropTypes.func,
};

CollapseCard.defaultProps = {
  title: null,
  removable: false,
  isOpen: false,
  onSelect: undefined,
  onRemove: undefined,
};

export default CollapseCard;
